import LeaderboardCard from './js/leaderboard-card';

export {
    LeaderboardCard
};
